// extracted by mini-css-extract-plugin
export default {"buttonForm":"ButtonForm_buttonForm__lktve"};